interface StatusBadgeProps {
  status: 'In Progress' | 'Scheduled' | 'Completed' | 'Pending' | 'Cancelled' | 'draft' | 'quoted' | 'scheduled' | 'in_progress' | 'completed' | 'cancelled' | string;
  className?: string;
}

export const StatusBadge = ({ status, className = '' }: StatusBadgeProps) => {
  const statusConfig: Record<string, { bg: string; text: string; ring: string }> = {
    'In Progress': {
      bg: 'bg-success/10',
      text: 'text-success',
      ring: 'ring-success/20',
    },
    'in_progress': {
      bg: 'bg-success/10',
      text: 'text-success',
      ring: 'ring-success/20',
    },
    'Scheduled': {
      bg: 'bg-primary/10',
      text: 'text-primary',
      ring: 'ring-primary/20',
    },
    'scheduled': {
      bg: 'bg-primary/10',
      text: 'text-primary',
      ring: 'ring-primary/20',
    },
    'Completed': {
      bg: 'bg-success/10',
      text: 'text-success',
      ring: 'ring-success/20',
    },
    'completed': {
      bg: 'bg-success/10',
      text: 'text-success',
      ring: 'ring-success/20',
    },
    'Pending': {
      bg: 'bg-warning/10',
      text: 'text-warning',
      ring: 'ring-warning/20',
    },
    'draft': {
      bg: 'bg-warning/10',
      text: 'text-warning',
      ring: 'ring-warning/20',
    },
    'quoted': {
      bg: 'bg-primary/10',
      text: 'text-primary',
      ring: 'ring-primary/20',
    },
    'Cancelled': {
      bg: 'bg-critical/10',
      text: 'text-critical',
      ring: 'ring-critical/20',
    },
    'cancelled': {
      bg: 'bg-critical/10',
      text: 'text-critical',
      ring: 'ring-critical/20',
    },
  };

  const config = status && (statusConfig[status] || statusConfig[status.toLowerCase()]) || {
    bg: 'bg-gray-50',
    text: 'text-gray-800',
    ring: 'ring-gray-200',
  };

  return (
    <span className={`inline-flex items-center rounded-full ${config.bg} px-2 py-1 text-xs font-medium ${config.text} ring-1 ring-inset ${config.ring} ${className}`}>
      {status || 'Unknown'}
    </span>
  );
};



